module.exports = __webpack_public_path__ + "img/360-matrum.8c4bb92e.jpg";